export default "__VITE_ASSET__BPL5KUgU__"